import { defaultTenant, profileDetails } from "../../services/academicService";
import {
  formatError,
  login,
  runLogoutTimer,
  saveTokenInLocalStorage,
  signUp,
} from "../../services/AuthService";
import { decodeToken } from "../../utils/authUtils";
import { handleBack } from "../../utils/backButton";

export const SIGNUP_CONFIRMED_ACTION = "[signup action] confirmed signup";
export const SIGNUP_FAILED_ACTION = "[signup action] failed signup";
export const LOGIN_CONFIRMED_ACTION = "[login action] confirmed login";
export const LOGIN_FAILED_ACTION = "[login action] failed login";
export const LOADING_TOGGLE_ACTION = "[Loading action] toggle loading";
export const LOGOUT_ACTION = "[Logout action] logout action";
export const AUTH_CHECKED_ACTION = "[auth action] auth checked";
export const NAVTOGGLE = "NAVTOGGLE";

export function signupAction(email, password, navigate) {
  return (dispatch) => {
    signUp(email, password)
      .then((response) => {
        saveTokenInLocalStorage(response.data);
        runLogoutTimer(
          dispatch,
          response.data.expires_in * 1000,
          //history,
        );
        dispatch(confirmedSignupAction(response.data));
        navigate("/dashboard");
        //history.push('/dashboard');
      })
      .catch((error) => {
        const errorMessage = formatError(error.response.data);
        dispatch(signupFailedAction(errorMessage));
      });
  };
}

export function Logout(navigate) {
  localStorage.removeItem("userDetails");
  localStorage.removeItem("sidebarState");
  localStorage.removeItem("selectedTenant");
  localStorage.removeItem("userName");
  localStorage.removeItem("role");
  navigate("/login");

  return {
    type: LOGOUT_ACTION,
  };
}

export function loginAction(email, password, navigate) {
  return async (dispatch) => {
    login(email, password)
      .then(async (response) => {
        if (!response || !response.data) {
          const errorMessage = "Login failed invalid email or password";
          dispatch(loginFailedAction(errorMessage));
          return;
        }

        if (response?.data) {
          const dec = decodeToken(response?.data?.access_token);

          const isSuperAdmin =
            dec?.realm_access?.roles?.includes("super_admin");

          let role = "";

          if (isSuperAdmin) {
            role = "super-admin";
          } else {
            const user = await profileDetails(response?.data?.access_token);

            // role = (
            //   user?.defaultTenant?.admin
            //     ? "admin"
            //     : user?.defaultTenant?.userType || ""
            // ).toLowerCase();

            const tenant = user?.defaultTenant;

            // role = (
            //   tenant?.admin === true ||
            //   (tenant?.admin === false && tenant?.userType === null)
            //     ? "admin"
            //     : tenant.userType
            // ).toLowerCase();
            if (tenant?.admin === true && tenant?.isSubscription) {
              role = "admin";
            } else if (!tenant?.isSubscription) {
              role = "tenant-admin"; // <-- new role
            } else {
              role = (tenant?.userType || "").toLowerCase();
            }
          }
          const allowedRoles = [
            "super-admin",
            "admin",
            "tenant-admin",
            "player",
            "coach",
          ];

          if (!allowedRoles.includes(role)) {
            dispatch(loginFailedAction("Invalid email or password"));
            return;
          }
          saveTokenInLocalStorage(response.data);
          runLogoutTimer(dispatch, response.data.expires_in * 1000, navigate);
          dispatch(loginConfirmedAction(dec, role));
          handleBack(role, navigate);
        }
      })

      .catch((error) => {
        console.log("Login Error: nj", error);
        const errorMessage = formatError(
          error?.response?.data || { message: "Something went wrong" },
        );
        dispatch(loginFailedAction(errorMessage));
      });
  };
}

export function loginFailedAction(data) {
  return {
    type: LOGIN_FAILED_ACTION,
    payload: data,
  };
}

export function loginConfirmedAction(data, role) {
  console.log("fetch 2", role);

  return {
    type: LOGIN_CONFIRMED_ACTION,
    payload: data,
    role: role,
    isAuthenticated: true,
  };
}

export function confirmedSignupAction(payload) {
  return {
    type: SIGNUP_CONFIRMED_ACTION,
    payload,
  };
}

export function signupFailedAction(message) {
  return {
    type: SIGNUP_FAILED_ACTION,
    payload: message,
  };
}

export function loadingToggleAction(status) {
  return {
    type: LOADING_TOGGLE_ACTION,
    payload: status,
  };
}

export function authCheckedAction() {
  return {
    type: AUTH_CHECKED_ACTION,
  };
}

export const navtoggle = () => {
  return {
    type: "NAVTOGGLE",
  };
};
